import React from 'react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import S from './MobileMainSwiper.module.css';

const MobileMainSwiper = ({ slides }) => {
  return (
    <div id='main-swiper-wrap' className='inner-container'>
      <Swiper
        slidesPerView={1}
        initialSlide={0}
        centeredSlides={true}
        rewind={true}
        loop={false}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className={S.swiperContent}>
              {/* <div className='font-white swiper-text'> */}
                <div className={S.swiperTitleText}>{slide.title}</div>
                <div className={S.swiperImgDiv}>
                  {slide.image && (
                    <img src={slide.image} alt={`메인이미지${index + 1}`} className={S.swiperImg} id={index === 3 ? S.swiperImg4 : ''} />
                  )}
                </div>
                <div className={S.swiperContentText}>
                  {slide.text && <p>{slide.text}</p>}
                </div>
              {/* </div> */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default MobileMainSwiper;
